import React from 'react';
import SearchIcon from 'assets/svgs/common/search.svg';
import {DebounceInput} from 'react-debounce-input';
import messages from '../messages';

const Search = ({value, onChange}) => (
  <div className="search-btn filter-item">
    <span>
      <img src={SearchIcon} alt="" />
    </span>
    <DebounceInput
      minLength={1}
      placeholder={messages.search}
      value={value}
      debounceTimeout={500}
      onChange={(event) => onChange(event.target.value)}
    />
  </div>
);

export default Search;
